export default ( state, { type, payload } ) => {
	switch ( type ) {
		case 'SET_STEP':
			return {
				...state,
				step: payload,
			};
		case 'SET_SHIPMENT':
			return {
				...state,
				shipment: payload,
			};
		case 'SET_UPLOAD':
			return {
				...state,
				upload: payload,
			};
		case 'SET_EMAILS':
			return {
				...state,
				emails: payload,
			};
		case 'SET_NOTIFY':
			return {
				...state,
				notify: payload,
			};
		case 'REMOVE_EMAIL':
			return {
				...state,
				emails: [
					...state.emails.slice( 0, payload ),
					...state.emails.slice( payload + 1 ),
				],
			};
		case 'SET_IS_LOADING':
			return {
				...state,
				isLoading: payload,
			};
		case 'SET_OVERLAY_VISIBILITY':
			return {
				...state,
				isOverlayVisible: payload,
			};
		case 'SET_CONFIRMED_CLOSE_VISIBILITY':
			return {
				...state,
				isConfirmedCloseVisible: payload,
			};
		case 'SET_IS_SAVED':
			return {
				...state,
				isSaved: payload,
			};
		case 'SET_SAVED_DISTRIBUTION_METHOD':
			return {
				...state,
				selectedDistributionMethod: payload,
			};
		default:
			return state;
	}
};
